// middleware/closeMenu.global.js
export default defineNuxtRouteMiddleware((to, from) => {
  // 클라이언트에서만 실행
  if (import.meta.client && from && to.path !== from.path) {
    const menuState = useMenuState()
    menuState.closeAllMenus()
  }
})